<template>
  <v-container>
    <div v-if="viewTable">
      <v-container>
        <v-row class="d-flex align-end">
          <v-col xs="3" md="3">
            <v-btn
              v-if="!readonly" 
              color="teal accent-4" 
              id="signers_document__nuevo_firmante__button" 
              outlined elevation="1" 
              @click="onNew"
            >
              Nuevo Firmante
            </v-btn>
          </v-col>
          <v-col xs="9" md="9">
            <div class="text-right">
              <v-container class="py-0">
                <v-row class="justify-end">
                  <label class="v-label mt-2 mr-4">Voy a firmar el documento</label>
                  <v-switch
                    id="signers_document__firmantes_voy_a_firmar__switch"
                    index="0"
                    class="mt-0"
                    v-model="userSignerCheck"
                    left
                    dense
                    inset
                    hide-details
                    label=""
                    :color="readonly ? 'grey' : 'teal accent-4'"
                    :loading="loadingMe"
                    :disabled="loadingMe"
                    :readonly="readonly"
                    @click.stop="stopEvent"
                  ></v-switch>
                </v-row>
              </v-container>
              <signer-switch
                index="1"
                class="py-0"
                v-model="firmarEnOrdenCheck"
                left
                dense
                inset
                hide-details
                readonly
                label="Respetar el orden de los firmantes"
              ></signer-switch>
              <document-generate-constancy
                v-if="signersValidation"
                :document="document"
                :id="`documents_table__constancia__button` + document.clave"
                type="button"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
      <signers-table-document
        id="signers_document__firmantes__table"
        class="pt-10"
        v-model="signersList"
        :showOrden="firmarEnOrdenCheck"
        :readonly="readonly"
        @clickUpdate="onEdit"
      ></signers-table-document>
    </div>
    <component
      :is="signerForm"
      id="signers_document__firmantes__form"
      unnotification
      v-model="signer"
      :documentId="document.idDocumento"
      :signersList="signersList"
      :type="typeForm"
      @created="onCreated"
      @updated="onUpdated"
      @cancel="onCancel"
    />
  </v-container>
</template>

<script>
import { userData, pushNotification, messageErrorResponse } from '@/store/helpers'
import DocumentGenerateConstancy from '@/modules/documents/components/DocumentGenerateConstancy'
import SignerSwitch from '@/modules/signers/components/commons/SignerSwitch'
import SignerFormDocument from '@/modules/signers/components/SignerFormDocument'
import SignersTableDocument from '@/modules/signers/components/SignersTableDocument'
import Signer from '@/models/Signer'

import {
  signersStoreActions
} from '@/modules/signers/store/signersStoreHelpers'

export default {
  name: 'SignersDocument',
  components: {
    DocumentGenerateConstancy,
    SignerSwitch,
    SignerFormDocument,
    SignersTableDocument
  },
  props: {
    value: {
      type: Array
    },
    document: {
      type: Object
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      viewTable: true,
      signer: new Signer(),
      signerForm: '',
      typeForm: 'add',
      loadingMe: false
    }
  },
  computed: {
    ...userData,
    signersList: {
      get() {
        return Object.assign([], this.value)
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    userSignerCheck: {
      get() {
        for (let signer of this.signersList) {
          if (signer.email == this.accountData.email) {
            return true
          }
        }
        return false
      }
    },
    firmarEnOrdenCheck() {
      return this.signersList.length > 0 && 
        +(this.signersList[0].orden) > 0 ? true : false
    },
    maxOrdern() {
      let orden = 0
      for (let signer of this.signersList) {
        orden = orden > +(signer.orden) ? orden : +(signer.orden)
      }
      return orden
    },
    signersValidation() {
      let list = this.document.firmantes.filter(s => s.firmado)
      return list.length == this.document.firmantes.length && this.document.estatus.descripcion == 'En proceso' 
    }
  },
  methods: {
    ...signersStoreActions,
    onNew() {
      let signer = new Signer()
      signer.firmarEnOrden = this.firmarEnOrdenCheck
      signer.orden = this.firmarEnOrdenCheck ? (this.maxOrdern + 1) : 0
      this.signer = signer
      this.typeForm = 'add'
      this.viewTable = false
      this.signerForm = 'SignerFormDocument'
    },
    onEdit(item) {
      this.signer = item
      this.typeForm = 'upd'
      this.viewTable = false
      this.signerForm = 'SignerFormDocument'
    },
    onCreated(signer) {
      let newList = Object.assign([], this.signersList)
      newList.push(signer)
      this.signersList = newList
      this.signerForm = ''
      this.viewTable = true

      let notificacion = {
        id: signer.id,
        notificacion: 1
      }
      this.reminderSignerToDocument(notificacion)
    },
    onUpdated(signer) {
      let newList = this.signersList.map(s => {
        return s.id == signer.id ? Object.assign(s, signer) : s
      })
      this.signersList = newList
      this.signerForm = ''
      this.viewTable = true
    },
    onCancel() {
      this.signerForm = ''
      this.viewTable = true
    },
    stopEvent(e){
      e.preventDefault()
      e.stopPropagation()
      
      if(this.readonly){
        return
      }
      
      let nexVal = !this.userSignerCheck
      if(nexVal) {
        let sig = this.signersList.find(s => s.email == this.accountData.email || s.rfc == this.accountData.rfc)
        if(sig == undefined){
          this.addMe()
        }else{
          pushNotification(
            this.$store,
            'Ya existe un firmate con el mismo correo o rfc',
            'error',
            'left',
            false,
            true
          )
        }
      }else {
        this.deleteMe()
      }
    },
    addMe(){
      this.loadingMe = true

      let data = {
        email: this.accountData.email,
        nombres: this.accountData.nombres,
        paterno: this.accountData.paterno,
        materno: this.accountData.materno,
        rfc: this.accountData.rfc,
        idDocumento: this.document.idDocumento,
        firmarEnOrden: this.firmarEnOrdenCheck,
        orden: this.firmarEnOrdenCheck ? (this.maxOrdern + 1) : 0
      }

      this.addSignerToDocument(data)
        .then(signer => {
          let newList = Object.assign([], this.signersList)
          newList.push(signer[0])
          this.signersList = newList

          let notificacion = {
            id: signer[0].id,
            notificacion: 1
          }
          this.reminderSignerToDocument(notificacion)
        })
        .catch(err => {
          this.notificationError(err)
        })
        .finally(() => {
          this.loadingMe = false
        })
    },
    deleteMe(){
      this.loadingMe = true

      let signer = this.signersList.find(s => s.email == this.accountData.email)
      if(signer == undefined){
        this.loadingMe = false
        return
      }

      this.deleteSignerToDocument(signer)
        .then(() => {
          let newList = this.signersList.filter(s => {
            return s.id != signer.id
          })
          this.signersList = newList
        })
        .catch(err => {
          this.notificationError(err)
        })
        .finally(() => {
          this.loadingMe = false
        })
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgSignerServiceError,
        'error',
        'left',
        false,
        true
      )
    }
  }
}
</script>
